import PageMeta from "../../../../shared/ui/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignUpForm from "../components/SignUpForm";

export default function SignUp() {
  return (
    <>
      <PageMeta/>
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}
